import React, { useEffect } from 'react';
import _ from 'lodash';

import SearchDetector from 'src/components/SearchDetector';
import { INITIAL_POLLING_INTERVAL } from 'src/constants/Generals';

const YearSelect = props => {
  const { uniqueString, year, formValues, location, searchReportWageLedger, fetchExportWageLedgerJobStatus } = props;

  useEffect(
    () => {
      if (_.isEmpty(year)) {
        return;
      }
      fetchExportWageLedgerJobStatus(INITIAL_POLLING_INTERVAL, year, uniqueString);
    },
    [year]
  );

  return (
    <SearchDetector
      location={location}
      year={year}
      willReceivePropsDetectingJudger={(prevProps, nextProps) =>
        !_.isEmpty(nextProps.year) && (_.isEmpty(prevProps.year) || nextProps.location !== prevProps.location)
      }
      onDetect={() => {
        searchReportWageLedger(formValues);
      }}
    />
  );
};

export default YearSelect;
